/**
 * 订单服务模块：创建订单、查询订单状态、获取订单列表等 API
 */

import { apiService } from './api'
import type {
  CreateOrderRequest,
  CreateOrderResponse,
  OrderApiResponse,
  OrderListData,
  OrderListParams,
  OrderStatusResponse,
} from '@/types/order'

const ORDER_ENDPOINT = '/api/user/orders' as const

/**
 * 创建订单（发起支付）
 * @param data 创建订单请求参数
 * @returns 订单创建响应，包含支付二维码 URL
 */
export async function createOrder(
  data: CreateOrderRequest
): Promise<CreateOrderResponse> {
  const response = await apiService.post<OrderApiResponse<CreateOrderResponse>>(
    ORDER_ENDPOINT,
    data
  )
  return response.data
}

/**
 * 查询订单支付状态
 * @param orderId 订单 ID
 * @returns 订单状态信息
 */
export async function getOrderStatus(
  orderId: string
): Promise<OrderStatusResponse> {
  const response = await apiService.get<OrderApiResponse<OrderStatusResponse>>(
    `${ORDER_ENDPOINT}/${orderId}/status`
  )
  return response.data
}

/**
 * 获取订单列表
 * @param params 查询参数
 * @returns 订单列表数据
 */
export async function getOrderList(
  params?: OrderListParams
): Promise<OrderListData> {
  const queryParams: Record<string, string> = {}

  if (params?.current !== undefined) {
    queryParams['current'] = String(params.current)
  }
  if (params?.pageSize !== undefined) {
    queryParams['pageSize'] = String(params.pageSize)
  }
  if (params?.status !== undefined && params.status !== 'all') {
    queryParams['status'] = params.status
  }

  const response = await apiService.get<OrderApiResponse<OrderListData>>(
    ORDER_ENDPOINT,
    queryParams
  )
  return response.data
}

/**
 * 取消订单
 * @param orderId 订单 ID
 */
export async function cancelOrder(orderId: string): Promise<void> {
  await apiService.post<OrderApiResponse<null>>(
    `${ORDER_ENDPOINT}/${orderId}/cancel`
  )
}
